import { BUYER_DASHBOARD_RECENT_ORDERS_REORDER } from "constants/action-types";
import { add as snackbarAdd } from "actions/snackbars";
import siteConfig from "site-config";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { push } from "react-router-redux";

export const reorderOrderEpic = (action$, store) =>
    action$
        .ofType(BUYER_DASHBOARD_RECENT_ORDERS_REORDER)
        .map(({ payload }) => payload)
        .mergeMap(({ orderId, brandId }) => {
            const request = {
                activeBrand: brandId,
                method: "POST",
                url: `${siteConfig.api}/working/clone/${orderId}`,
            };
            // should at least put something in cart
            return ajax(request)
                .map((response) => {
                    return response;
                })
                .mergeMap((moreStuff) => {
                    return [push(`/brand/${brandId}/cart/reorder`)];
                })
                .catch((error) => [snackbarAdd({ message: "There was an error re-ordering your order" })]);
        });
